import { Navigation } from "@/components/Navigation";
import { HeroSection } from "@/components/HeroSection";
import { AboutSection } from "@/components/AboutSection";
import { DrinksMenu } from "@/components/DrinksMenu";
import { FoodMenu } from "@/components/FoodMenu";
import { EventsSection } from "@/components/EventsSection";
import { GallerySection } from "@/components/GallerySection";
import { ContactSection } from "@/components/ContactSection";
import { ReservationSection } from "@/components/ReservationSection";
import { Footer } from "@/components/Footer";
import { MaintenanceBanner } from "@/components/MaintenanceBanner";

const Index = () => {
  return (
    <main className="min-h-screen bg-background">
      <MaintenanceBanner />
      <Navigation />
      <HeroSection />
      <AboutSection />
      <DrinksMenu />
      <FoodMenu />
      <EventsSection />
      <GallerySection />
      <ContactSection />
      <ReservationSection />
      <Footer />
    </main>
  );
};

export default Index;
